import styled from 'styled-components'

import { ArrowRight } from './Icons'

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex: 1;
  min-width: 0;
`

export const FlexColumn = styled.div`
  display: flex;
  flex-direction: column;
`

export const Column = styled.div`
  display: block;
`

export const MaxColumn = styled(Column)`
  width: 100%;
`

export const FormLabel = styled.label`
  font-size: 14px;
  font-weight: bold;
  color: #3a3a3a;
`

export const PrimaryButton = styled.input`
  background: var(--wg-blue-link);
  border: 1px solid #6497cf;
  border-radius: 4px;

  margin-left: 0.5rem;
  min-width: 120px;
  padding: 1rem;
  text-align: center;
  font-size: 14px;
  color: #ffffff;

  transition: box-shadow 0.1s;

  &:hover {
    box-shadow: rgba(0, 0, 0, 0.3) 0px 0px 4px;
  }
  cursor: pointer;
`

export const SecondaryButton = styled(PrimaryButton)`
  background: #ffffff;
  border: 1px solid #cbd6e2;

  &:hover {
    box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 4px;
  }
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity));
`

export const Contents = styled.div`
  background-color: #f2f4f6;
  align-items: flex-start;
  display: flex;
  flex-direction: row;
  border-radius: 10px;
  min-height: 300px;
  width: 100%;
  margin-top: 20px;
  padding: 20px 40px 40px;
`

export const AccordionIcon = styled(({ isOpen, alignLeft, ...rest }) => <ArrowRight {...rest} />)<{
  isOpen?: boolean
  alignLeft?: boolean
}>`
  width: 10px;
  height: 10px;
  transition: transform 0.1s;
  margin-right: 2px;
  margin-left: ${props => (props.alignLeft ? '-5px' : '5px')};
  transform: ${props => (props.isOpen ? 'rotate(90deg)' : 'rotate(0deg)')};
  polygon {
    stroke: #3a3a3a;
    stroke-width: 2px;
  }
`
